export enum TournamentCancellationReason {
    TECHNICAL_FAILURE = 'TECHNICAL_FAILURE',
    EQUIPMENT_FAILURE = 'EQUIPMENT_FAILURE',
    BOTH_PARTICIPANTS_ARE_MISSING = 'BOTH_PARTICIPANTS_ARE_MISSING',
    OTHER = 'OTHER',
}
